import React, { useMemo, useRef } from 'react';
import { Button } from 'antd';
import { AgGridReact } from 'ag-grid-react';
    

import {
  expenseConfig, 
} from './expense.config';
import { useNavigate } from 'react-router-dom';
//import { Expense } from '../../types/expense.types';
import { PLGrid } from '../../components/common/PLGrid';
import { GridResetButton } from '../../components/common/GridResetButton';
import ExportAgCSVButton from '../../components/common/ExportAgCSVButton';
import { serialNumberColumn } from '../../libs/getSerialNumberColumn';
import { useDeleteHandler } from '../../hooks/useDeleteHandler';
import { useGridData } from '../../hooks/useGridData';
import { getActionColumn } from '../../libs/getActionColumn';
import BulkUploadButton from '../../components/common/BulkUploadButton';
type Expense=any
const ExpenseList: React.FC = () => {
  const gridRef = useRef<AgGridReact>(null);
  const { rowData, loading, refetch } = useGridData<Expense>(expenseConfig.api.fetchAll);
  const deleteHandler = useDeleteHandler(); 
  const navigate = useNavigate();

  const actionColumn = useMemo(() =>
    getActionColumn<Expense>({
      viewUrl: (row: Expense) => `${expenseConfig.redirectPath}/view/${row._id}`,
      editUrl: (row: Expense) => `${expenseConfig.redirectPath}/edit/${row._id}`,
      onDelete: (row: Expense) => deleteHandler({
        id: row._id,
        entityName: expenseConfig.entityName,
        deleteApi: expenseConfig.api.delete,
        onSuccess: ()=>refetch()
      }),
    }), [deleteHandler]
  );

  const columnDefs = useMemo(() => [
    serialNumberColumn,
    ...expenseConfig.expenseTableColumns,
    actionColumn,
  ], [actionColumn]);

  return (
    <div className="h-full flex flex-col">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold m-0">{expenseConfig.entityName} List</h2>
        <div className="flex items-center gap-2">
          <GridResetButton gridRef={gridRef} />
          <ExportAgCSVButton gridRef={gridRef} fileName={`${expenseConfig.entityName}List`} />
          <BulkUploadButton redirectPath={`${expenseConfig.redirectPath}/excel-upload`} />
          <Button type="primary" onClick={() => navigate(`${expenseConfig.redirectPath}/create`)}>
            Create {expenseConfig.entityName}
          </Button>
        </div>
      </div>

      <div className="flex-1 overflow-x-auto">
        <PLGrid
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default ExpenseList;

